<template>
  <v-dialog v-model="dialog" width="600" scrollable persistent>
    <BaseBodyDialog @close="closeDialog" @save="onCreate" title="Tạo lịch nghỉ">
      <v-form class="pt-4">
        <div class="text-body-2 font-weight-medium mb-3">1. Thông tin cơ bản</div>
        <div class="d-flex">
          <div style="width: 50%" class="mr-2">
            <GradeClassStudentSelect
              @changed="gradeClassStudentChange"
              :classCol="{ cols: 12, sm: 12, md: 12 }"
              disableGradeSelect
              disableStudentSelect
              :key="key"
            />
          </div>

          <div style="width: 50%">
            <v-autocomplete
              :items="dates"
              item-text="title"
              item-value="value"
              v-model="date"
              outlined
              dense
              hide-details
              :disabled="isDatepickerDisabled"
              label="Ngày nghỉ"
              placeholder="Chọn buổi học cần nghỉ"
            />
          </div>
        </div>

        <v-textarea class="mt-2" outlined full-width no-resize placeholder="Ghi chú" v-model="notes" dense />
        <div class="text-body-2 font-weight-medium">2. Thông tin học bù</div>
        <v-switch v-model="isMakeup" :label="isMakeup ? 'Có học bù' : 'Không học bù'" hide-details />
        <div v-if="isMakeup" class="mt-3">
          <DateIOSPicker :date.sync="makeupDate" label="Ngày học bù" dense outlined />
          <div class="d-flex mt-2">
            <div style="width: 50%" class="mr-2">
              <TimeInputString label="Giờ bắt đầu" outlined dense outline :date.sync="makeupStartTime" />
            </div>
            <div style="width: 50%">
              <TimeInputString label="Giờ kết thúc" outlined dense outline :date.sync="makeupEndTime" />
            </div>
          </div>

          <AutocompleteClassroom
            class="mt-2"
            v-model="makeupClassroom"
            clear-icon="mdi-close"
            label="Phòng học"
            outlined
            dense
            hide-details
          />
        </div>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>
<script>
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import TimeInputString from '@/components/basic/TimeInputString.vue'
import AutocompleteClassroom from '@/components/basic/input/AutocompleteClassroom.vue'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

import get from 'lodash-es/get'
import uniqBy from 'lodash-es/uniqBy'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: { GradeClassStudentSelect, TimeInputString, AutocompleteClassroom, BaseBodyDialog, DateIOSPicker },
  data: () => ({
    // dialog
    dialog: false,
    dates: [],
    key: '',
    // to create
    classId: null,
    date: null,
    notes: null,
    isMakeup: false,
    makeupDate: null,
    makeupStartTime: null,
    makeupEndTime: null,
    makeupTeachers: [],
    makeupClassroom: null,
  }),
  computed: {
    isDatepickerDisabled() {
      return this.dates.length < 1
    },
  },
  methods: {
    ...mapActions({
      create: 'scheduleVacation/create',
      search: 'scheduleVacation/search',
      fetchLessonIndependent: 'lesson/fetchLessonIndependent',
    }),
    openDialog() {
      this.reset()
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.key = Date.now().toString()
    },
    async gradeClassStudentChange(data) {
      const classId = get(data, 'class.id')
      if (classId) {
        const lessons = await this.fetchLessonIndependent({ class: classId, _sort: 'date:ASC' })
        if (Array.isArray(lessons) && lessons.length) {
          this.dates = uniqBy(
            lessons.map(x => ({ title: moment(x.date).format('DD/MM/YYYY'), value: x.date })),
            x => x.title
          )
        } else return this.$alert.error('Lớp học chưa được xếp lịch học. Vui lòng xếp lịch học cho lớp học trước')
      }
      this.classId = get(data, 'class.id')
      this.makeupTeachers = get(data, 'class.teachers')
    },
    validate() {
      if (!this.date || !this.classId) return false
      if (this.isMakeup) {
        if (!this.makeupDate || !this.makeupStartTime || !this.makeupEndTime) return false
      }

      return true
    },
    async onCreate() {
      const isValid = this.validate()
      if (!isValid) return this.$alert.error('Vui lòng nhập đầy đủ các trường thông tin')
      try {
        this.$loading.active = true
        await this.create({
          class: this.classId,
          date: this.date,
          notes: this.notes,
          isMakeup: this.isMakeup,
          makeupDate: this.makeupDate,
          makeupStartTime: this.makeupStartTime,
          makeupEndTime: this.makeupEndTime,
          makeupTeachers: this.makeupTeachers,
          makeupClassroom: get(this.makeupClassroom, 'id'),
        })
        await this.search({})
        this.$alert.success('Tạo lịch nghỉ thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
